import React, { useEffect } from "react";
import { useDispatch, useSelector as useReduxSelector } from "react-redux";
import SendToAppModal from "web/react/components/send-to-app-modal/send-to-app-modal";
import { useOverlayWatcher } from "web/react/hooks/use-overlay-watcher/use-overlay-watcher";
import { closeGenericModal, GenericModal } from "web/redux/ducks/send-to-app-modal";
import { ReduxStoreState } from "web/redux/store";
import { gettext } from "web/script/modules/django-i18n";
import { RawBranchLink } from "web/script/utils/branch-io";
import history from "web/script/utils/history";

function extractState(state: ReduxStoreState): GenericModal {
    return state.sendToAppModalReducer.genericModal;
}

const APP_MODAL_NAME = "send-to-app-modal";

export default function SendToAppModalContainer(): JSX.Element | null {
    const dispatch = useDispatch();
    const { openModal, modalType, product } = useReduxSelector(extractState);
    const keepModalOpen = !!useOverlayWatcher(APP_MODAL_NAME);
    useEffect(() => {
        if (!keepModalOpen) {
            dispatch(closeGenericModal());
            history.popOverlay(APP_MODAL_NAME);
        }
    }, [keepModalOpen, dispatch]);

    useEffect(() => {
        if (openModal) {
            // I check the current overlay state instead of modalIsOpen
            // to get around the delay introduced by hooks
            if (history.getCurrentState().overlay !== APP_MODAL_NAME) {
                history.pushOverlay(APP_MODAL_NAME);
            }
        }
    }, [openModal]);

    let branchLink = "";
    let title = "";
    let analyticsEventLabel;
    let continueOption;

    function onClose(): void {
        history.popOverlay(APP_MODAL_NAME);
    }

    if (modalType === "timed-modal") {
        // "All your fashion needs in one app"
        title = gettext("app_overlay_block.fashion_needs.title");
        branchLink = RawBranchLink.AppSignupTimedBlock;
        analyticsEventLabel = "timed_session_block";
    } else {
        title = gettext("feed.show_more.app_overlay_block.title_4");
        branchLink = RawBranchLink.ShowMore;
        analyticsEventLabel = "feeds_show_more";
    }

    if (!modalType) {
        return null;
    } else {
        return (
            <SendToAppModal
                isOpen={openModal}
                onClose={onClose}
                title={title}
                url={branchLink}
                analyticsEventLabel={analyticsEventLabel}
                productImageURL={product?.productImageUrl}
                extraContent={(): JSX.Element => {
                    return continueOption;
                }}
            />
        );
    }
}
